import React, { useContext, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ErrorMessage } from '@hookform/error-message';
import { fetchData, USER_LIST, TERMS_AND_CONDITIONS } from '../../components/Service';
import { toastNotify } from '../../components/Helper';
import { Context } from "../../components/Context";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import Cookies from 'universal-cookie';
import configData from "../../config.json";
import moment from 'moment';
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import "react-datepicker/dist/react-datepicker.css";
import './auth.scss';

const theme = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary50: '#70bc1f',
        primary25: '#e8f3db',
        primary: '#70bc1f',
    },
})

const Registration = () => {
    const cookies = new Cookies();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    window.document.title = `${t('Registration')} | ${t('Panda')}`;

    const MOMENT_DATE_YMD = configData.formate.moment.ymd.date;
    const DATEPICKER_DATE = configData.formate.datepicker.dmy.date;

    const cities = [
        { value: '1', label: t('Jeddah') },
        { value: '2', label: t('Makkah') },
        { value: '3', label: t('Riyadh') },
        { value: '4', label: t('AlMadinah') },
        { value: '5', label: t('Taif') },
        { value: '6', label: t('Dammam') },
        { value: '7', label: t('Buraidah') },
        { value: '8', label: t('Unaizah') },
        { value: '9', label: t('Khobar') },
        { value: '10', label: t('Dharan') },
        { value: '11', label: t('Kharj') },
        { value: '12', label: t('Al - Hassa') },
        { value: '13', label: t('Abha') },
        { value: '14', label: t('Khamis Mushait') },
        { value: '15', label: t('Yanbu') },
        { value: '16', label: t('Jubail') },
        { value: '17', label: t('AlLeeth') },
        { value: '18', label: t('Dawadmi') },
        { value: '19', label: t('Jazan') },
        { value: '20', label: t('Khulais') },
        { value: '21', label: t('Hail') },
        { value: '22', label: t('Tabuk') },
        { value: '23', label: t('Qateef') },
        { value: '24', label: t('Sihat') },
        { value: '25', label: t('AlBaha') },
        { value: '26', label: t('Hafr Al Baten') },
        { value: '27', label: t('Ras Tanourah') },
        { value: '28', label: t('Khafji') },
        { value: '29', label: t('Abqaiq') },
        { value: '30', label: t('Muhayel') },
        { value: '31', label: t('Bisha') },
        { value: '32', label: t('Najran') },
        { value: '33', label: t('Al Rass') },
        { value: '34', label: t('Al Majmaah') },
        { value: '35', label: t('Bekairiyah') },
        { value: '36', label: t('KAEC') },
        { value: '37', label: t('Abo Arish') },
        { value: '38', label: t('Ahad Al Masarha') },
        { value: '39', label: t('Al Badaea') },
        { value: '40', label: t('Baljorashi') },
        { value: '41', label: t('Hawtat Sudryer') },
        { value: '42', label: t('Hotat bani Tamim') },
        { value: '43', label: t('Quwayiyah') },
        { value: '44', label: t('Rabigh') },
        { value: '45', label: t('Sabyah') },
        { value: '46', label: t('Sarat Abydah') }
    ]


    const maritalStatus = [
        { value: 'single', label: t('Single') },
        { value: 'married', label: t('Married') },
        { value: 'other', label: t('Other') }
    ]

    const noOfFamilyMember = [
        { value: '0', label: '00' },
        { value: '1', label: '01' },
        { value: '2', label: '02' },
        { value: '3', label: '03' },
        { value: '4', label: '04' },
        { value: '5', label: '05' }
    ]

    const stores = {
        '3': [
            { value: '10003', label: t('Alia Mall Abo Baker') },
            { value: '10004', label: t('Salboukh') },
            { value: '10022', label: t('Galaria (Ex Geant)') },
            { value: '101', label: t('Othman') },
            { value: '129', label: t('Al Sahafa') },
            { value: '155', label: t('Qurtoba') },
            { value: '156', label: t('Al Thumama Mall') },
            { value: '161', label: t('Al Monsyah') },
            { value: '164', label: t('Othman Bin Afan St.') },
            { value: '170', label: t('Masharef') },
            { value: '100', label: t('Hyper  Takhasusi') },
            { value: '10010', label: t('Um Al Hammam') },
            { value: '10026', label: t('Al Maathar ') },
            { value: '10029', label: t('Al Orobah Plaza') },
            { value: '1', label: t('Olaya Thalateen') },
            { value: '3', label: t('Sulemaniah') },
            { value: '13', label: t('Mursalat') },
            { value: '104', label: t('Izdihar') },
            { value: '114', label: t('Abubakr') },
            { value: '125', label: t('Exit-2(Ex-Geant)') },
            { value: '10013', label: t('Shaikh Jabir') },
            { value: '10014', label: t('Yarmouk') },
            { value: '10020', label: t('Khurais Plaza (Ex Geant)') },
            { value: '110', label: t('Al Quds-Re Opened') },
            { value: '116', label: t('Prince Bandar St.') },
            { value: '117', label: t('Al Nazeem') },
            { value: '119', label: t('Eshbiliah') },
            { value: '135', label: t('Salman Al Farsi Site') },
            { value: '140', label: t('Al Nazeem, Nadwah Street') },
            { value: '143', label: t('Yarmouk') },
            { value: '10006', label: t('Gs Riyadh Bilal Abn Rabah') },
            { value: '10012', label: t('Al Badiah Plaza ') },
            { value: '10018', label: t('Al Makan Mall - Dawadmi') },
            { value: '6', label: t('Olysha') },
            { value: '26', label: t('Olysha') },
            { value: '124', label: t(' Al Jazirah Complex') },
            { value: '127', label: t('Dahiat Laban') },
            { value: '136', label: t('Al Fayhaa') },
            { value: '139', label: t('Muzamiah Mall, Makkah Road') },
            { value: '158', label: t('Maan Bin Zaydah') },
            { value: '10007', label: t('Hamzah Rd') },
            { value: '10021', label: t('Salaam Mall (Ex Geant)') },
            { value: '102', label: t('Al Tarmathi') },
            { value: '115', label: t('Alshifa') },
            { value: '118', label: t('Azizia') },
            { value: '121', label: t('Al Yasmeen Mall') },
            { value: '131', label: t('Al Dar Albydah') },
            { value: '132', label: t('Diyrab') },
            { value: '137', label: t('Mercato Mall') },
            { value: '144', label: t('Al Shifa') },
            { value: '10002', label: t('Rimal Mall') },
            { value: '10008', label: t('Al Rayan') },
            { value: '4', label: t('Wizarat') },
            { value: '5', label: t('Batha') },
            { value: '7', label: t('Naseem') },
            { value: '8', label: t('Rabwah') },
            { value: '120', label: t('Al Naseem') },
            { value: '146', label: t('Al Nasim West') },
        ],

        '41': [
            { value: '175', label: t(' Hawtat Sudyer ') },
        ],

        '43': [
            { value: '168', label: t('Quwayiyah') },
        ],

        '11': [
            { value: '10023', label: t('Jaw Mall-Kharj (Ex Geant)') },
            { value: '128', label: t('Al Oyon') },
            { value: '138', label: t('Al Wrood Plaza') },
        ],

        '7': [
            { value: '30001', label: t('Shahinat') },
            { value: '34', label: t('Al Madina Street') },
            { value: '138', label: t('Al Wrood Plaza') },
            { value: '308', label: t('Gs Qassim-Dari Road') },
            { value: '313', label: t('Sultana') },
            { value: '314', label: t('Al Fayzeah Box') },
        ],

        '21': [
            { value: '30004', label: t('Wsaita') },
            { value: '302', label: t('Hail') },
            { value: '306', label: t('Hail Sadyan') },
        ],

        '35': [
            { value: '37', label: t('Bekairiyah') },
        ],

        '8': [
            { value: '301', label: t('Onaizah') },
            { value: '311', label: t('Onaizah Village') },
        ],

        '34': [
            { value: '304', label: t('Majmaa') },
        ],

        '33': [
            { value: '316', label: t('Al Khaleefa Park Centre') },
        ],

        '4': [
            { value: '50001', label: t('Aliat Al Madina') },
            { value: '50003', label: t('Noor Mall Madinah (Ex Geant)') },
            { value: '502', label: t('Hassan Mall Madinah') },
            { value: '503', label: t('Almanar Mall Madinah') },
        ],

        '15': [
            { value: '50002', label: t('Dana Yanbu') },
        ],

        '22': [
            { value: '501', label: t('King Abdulaziz Road, Tabuk') },
            { value: '505', label: t('Al Baher city ') },
        ],

        '16': [
            { value: '453', label: t('Gs Jubail -Prince Mashor St.') },
            { value: '40013', label: t('King Faisal') },
            { value: '46', label: t('Al Fardous') },
            { value: '51', label: t('Faiha') },
            { value: '405', label: t('Al Huwailat Center (Kinan)') },
            { value: '406', label: t('Najd') },
            { value: '411', label: t('Aldakhl Almahdood') },
            { value: '413', label: t('Al Qudus Complex (Khonaini)') },
            { value: '422', label: t('Taiba Mall') },
            { value: '426', label: t('Prince Naif') },
        ],

        '12': [
            { value: '404', label: t('Al Hassa') },
            { value: '410', label: t('Al Nakheel Plaza Hafuf') },
            { value: '416', label: t('Rawda Mall ') },
            { value: '423', label: t('Al Hassa - Ring road') },
            { value: '424', label: t('Al Umran') },
            { value: '434', label: t('Al Ferdus Box') },
            { value: '407', label: t('Al Hafouf') },
        ],

        '29': [
            { value: '412', label: t('Abqaiq') },
        ],

        '6': [
            { value: '40012', label: t('Dareen Mall') },
            { value: '40016', label: t('AlNada (Al Faisalyia)') },
            { value: '42', label: t('Dammam') },
            { value: '403', label: t('Abdulaziz Road') },
            { value: '429', label: t('Dahya King Fahad 2') },
            { value: '40005', label: t('King Saud') },
            { value: '40006', label: t('Andalusia Mall') },
            { value: '40011', label: t('GS-Dammam 3Al Raian') },
            { value: '421', label: t('Omar Site') },
            { value: '428', label: t('Dahya - 1') },
            { value: '436', label: t(' Al Shati') },
            { value: '452', label: t('Gs Dammam -Bader') },
        ],

        '27': [
            { value: '402', label: t('Ras Tanoura') },
        ],

        '26': [
            { value: '425', label: t('King Khaled Base') },
            { value: '417', label: t('Hafr Al Baten Site') },
            { value: '40008', label: t('Hafr Albaten Mall') },
        ],

        '23': [
            { value: '457', label: t('Gs Qatif-Ahed Street') },
        ],

        '28': [
            { value: '438', label: t('Khafji Box') },
        ],

        '10': [
            { value: '40004', label: t('Jarir Palaza') },
            { value: '40020', label: t('Dahran Mall  (Ex Geant)') },
            { value: '408', label: t('Doha Mall') },
        ],

        '9': [
            { value: '40009', label: t('Raka Al Rakkah Dammam') },
            { value: '409', label: t('Al Rakkah') },
            { value: '420', label: t('Al Jiser Site') },
            { value: '427', label: t('Al Aziziya') },
            { value: '435', label: t('Al Khuzamyah Site') },
            { value: '455', label: t('Gs Aqrabia-Prince Moqrin St.') },
            { value: '456', label: t('Gs Swaiket-Prince Muqm Street') },
            { value: '458', label: t('Gs Raka -Andalus Street') },
        ],

        '1': [
            { value: '251', label: t('Gs Jeddah  King - Road') },
            { value: '20001', label: t('Roshan Mall') },
            { value: '20007', label: t('Hinaki, Hamdaniya') },
            { value: '20008', label: t('North Obhur ') },
            { value: '20021', label: t('Mall Of Arabia (Ex Geant)') },
            { value: '241', label: t('Al-Rohaily') },
            { value: '20006', label: t('Mutib Street') },
            { value: '20009', label: t('GS-Faisaliah') },
            { value: '20025', label: t('Sari Land') },
            { value: '201', label: t('Safa') },
            { value: '202', label: t('Rawdah') },
            { value: '205', label: t('Taiba Mall') },
            { value: '214', label: t('Ghirnatah') },
            { value: '236', label: t('Hai Al Sammer ') },
            { value: '237', label: t('Madina Press') },
            { value: '20003', label: t('Andalus Mall') },
            { value: '20004', label: t('Jamea Mall') },
            { value: '20012', label: t('Al Birr Society') },
            { value: '207', label: t('Madaen Al Fahad') },
            { value: '210', label: t('Waziriah ') },
            { value: '240', label: t('Palastain ') },
        ],

        '44': [
            { value: '223', label: t('KAEC') },
            { value: '227', label: t('Rabigh') },
        ],

        '5': [
            { value: '20010', label: t('Al Malaika Mall Taif') },
            { value: '204', label: t('Obaiken Mall Taif') },
        ],

        '2': [
            { value: '20002', label: t('Kakiyah') },
            { value: '20011', label: t('Awali Makkah') },
            { value: '20024', label: t('Al Jumum Mall') },
            { value: '203', label: t('Al Nawaryah') },
            { value: '208', label: t('Al Sharaee Makkah') },
            { value: '209', label: t('Makkah Mall') },
            { value: '220', label: t('Iskan Al Resaifa') },
            { value: '225', label: t('Jed - Mak Takhasusi') },
            { value: '239', label: t('Bathaa Quraysh ') },
        ],

        '19': [
            { value: '70007', label: t('Hinawi, Jizan') },
            { value: '703', label: t('Rashid Mall') },
        ],

        '13': [
            { value: '70006', label: t('Gs Abha Abha Street') },
            { value: '701', label: t('Abha') },
            { value: '716', label: t('AlRashid Mall') },
        ],

        '32': [
            { value: '70002', label: t('Najran Mall') },
        ],

        '14': [
            { value: '70005', label: t('Khamis Mushait') },
            { value: '702', label: t('Khamis') },
            { value: '708', label: t('Ben Ghamiya Plaza') },
        ],

        '31': [
            { value: '70001', label: t('Beishah') },
        ],

        '46': [
            { value: '711', label: t('Al Waha Plaza Mall ') },
        ],

        '30': [
            { value: '70004', label: t('Muhayel Aseer - Al Makan Mall') },
            { value: '710', label: t('Albasatin Mall') },
        ],

        '45': [
            { value: '70009', label: t('Sabyah Mall') },
        ],

        '38': [
            { value: '70010', label: t('Al Ahad Land') },
        ],

        '37': [
            { value: '705', label: t('Abo Arish Mall') },
        ],

        '40': [
            { value: '706', label: t('Al Atiya Mall ') },
        ],

        '25': [
            { value: '707', label: t('Al Baha Mall') },
        ]
    }

    const categories = [
        { value: '1', label: t('Packed Beverages') },
        { value: '2', label: t('Packed Fruit Juices') },
        { value: '3', label: t('Bread & bakery') },
        { value: '4', label: t('Breakfast & cereals') },
        { value: '5', label: t('Canned foods & Soups') },
        { value: '6', label: t('Condiments, Spices and nuts') },
        { value: '7', label: t('Cookies, snacks & candy') },
        { value: '8', label: t('Delicatessen') },
        { value: '9', label: t('Dairy, Eggs & Cheese') },
        { value: '10', label: t('Fresh meat & fish') },
        { value: '11', label: t('Fresh fruits and vegetables') },
        { value: '12', label: t('Grains and Pasta') },
        { value: '19', label: t('Rice') },
        { value: '14', label: t('Sauces and oils') },
        { value: '15', label: t('Frozen foods') },
        { value: '16', label: t('Paper product & Tissues') },
        { value: '17', label: t('Health, beauty & personal care') },
        { value: '18', label: t('Cleaning supplies') },
        { value: '19', label: t('Baby toddler items') }

    ]

    const [preferStore, setPreferStore] = useState([])
    const [preferStoreIndex, setPreferStoreIndex] = useState()
    const [startDate, setStartDate] = useState(new Date());
    const { handleSubmit, register, setValue, getValues, setError, formState: { errors }, } = useForm();
    const [context, setContext] = useContext(Context);
    const [steps, setSteps] = useState(1)
    const [reload, setReload] = useState(false);
    const [termsAndConditions, setTermsAndConditions] = useState(false)
    const [progress, setProgress] = useState(0)

    const goToStep = (step, next = true) => {
        let updated_step = next ? step + 1 : step - 1;

        if (updated_step <= 3 && updated_step >= 1) {
            setSteps(updated_step)

            document.querySelectorAll(".step").forEach(function (el) {
                el.classList.add('hidden')
            })

            document.querySelector(`.step${updated_step}`).classList.remove('hidden')
        }
    }

    const startDateHeandler = (date) => {
        if (!moment(date, MOMENT_DATE_YMD, true).isValid()) {
            setError('birthdate', { type: 'custom', message: t('Invalid Data Format') });
        }
        setStartDate(date);
        setValue('birthdate', moment(date).format(MOMENT_DATE_YMD));
    }

    async function submitRegistration(formdata) {
        try {
            if (steps !== 3) {
                goToStep(steps, true)
            }
            if (context && context.id && steps === 3) {
                setReload(true);

                let cat_ids = []

                if (getValues('category_preference') && getValues('category_preference').length > 0) {
                    getValues('category_preference').map(item => {
                        if (item.value) {
                            cat_ids.push(parseInt(item.value))
                        } else {
                            cat_ids.push(parseInt(item))
                        }
                    });
                }

                var shop_preference = []
                if (getValues('how_you_want_to_shop_online')) {
                    shop_preference.push("online")
                }
                if (getValues('how_you_want_to_shop_instore')) {
                    shop_preference.push("in-store")
                }

                let user_info = {
                    "firstname": getValues('firstname') ?? '',
                    "lastname": getValues('lastname') ?? '',
                    "email": getValues('email') ?? '',
                    "marketing_opt_email": getValues('marketing_opt_email').toString() == 'true' ?? false,
                    "marketing_opt_mobile": getValues('marketing_opt_mobile').toString() == 'true' ?? false,
                    "is_terms_accepted": context.is_terms_accepted || (getValues('is_terms_accepted')?.toString() == 'true' || false),
                    "birthdate": getValues('birthdate') ?? '',
                    "gender": getValues('gender') ?? '',
                    "additional_info": {
                        "city_id": getValues('no_of_cities') ? parseInt(getValues('no_of_cities')) : '',
                        "address": getValues('address') ?? '',
                        "marital_status": getValues('marital_status') ?? '',
                        "household": {
                            "adults": getValues('adults') ? parseInt(getValues('adults')) : 0,
                            "children": getValues('children') ? parseInt(getValues('children')) : 0,
                        },
                        "store_location": getValues('store_location') ? [getValues('store_location')] : [],
                        "category_ids": cat_ids,
                        "shop_preference": shop_preference
                    }
                }

                fetchData(USER_LIST + '/' + context.id, 'PATCH', { user: user_info }, true, false, (res) => {
                    if (res.status) {
                        var userInfo = cookies.get('user');
                        let userNewData = res.data.user

                        userNewData.key = userInfo && userInfo.key
                        userNewData.verify_id = userInfo && userInfo.verify_id
                        userNewData.is_loyalty_customer = context.is_loyalty_customer
                        userNewData.is_anonymous = context.is_anonymous

                        cookies.remove('user');

                        setContext(userNewData)

                        cookies.set('user', userNewData);

                        toastNotify('success', t('Updated successfully'))
                        navigate('/admin/dashboard');
                    } else {
                        res.error && res.error.message && toastNotify('danger', res.error.message ? res.error.message : t('Something went wrong'));
                    }
                    setReload(false);
                });
            }
        } catch (err) {
            toastNotify('danger', t('Invalid action perform'));
        }
    }

    const showTC = () => {
        fetchData(TERMS_AND_CONDITIONS, 'GET', '', true, false, (res) => {
            if (res.status) {
                setTermsAndConditions(t('Panda plus terms'))

            } else {
                res.error && res.error.message && toastNotify('danger', res.error.message ? res.error.message : t('Something went wrong'));
            }
            setReload(false);
        });
    }

    const acceptTC = () => {
        setValue('is_terms_accepted', true)
        setTermsAndConditions(false)
    }

    const handleProgress = () => {
        let stepProgress = (100 / 15).toFixed(3)
        let totalFilledField = 0

        for (const key of Object.keys(getValues())) {
            if ((key !== 'category_preference' && getValues(key)) || (key === 'category_preference' && Array.isArray(getValues(key)) && getValues(key).length > 0)) {
                totalFilledField++
            }
        }

        if ((stepProgress * totalFilledField) > 100) {
            setProgress(100)
        } else {
            setProgress(parseInt(stepProgress * totalFilledField))
        }
    }

    const updateStoreList = (city) => {
        setPreferStore(stores[city])
    }

    context.is_loyalty_customer = context.crm_loyalty_number != ""

    useEffect(() => {
        setValue('firstname', context && context.firstname)
        setValue('lastname', context && context.lastname)
        setValue('mobile', context && context.mobile)
        setValue('email', context && context.email)
        setValue('marketing_opt_email', context && context.marketing_opt_email)
        setValue('marketing_opt_mobile', context && context.marketing_opt_mobile)
        setValue('gender', context && context.gender)
        setValue('birthdate', context && context.birthdate ? context.birthdate : moment(startDate).format(MOMENT_DATE_YMD))
        setValue('address', context && context.additional_info && context.additional_info.address)
        setValue('no_of_cities', context && context.additional_info && context.additional_info.city_id)
        setValue('marital_status', context && context.additional_info && context.additional_info.marital_status)
        setValue('adults', context && context.additional_info && context.additional_info && context.additional_info.household && context.additional_info.household.adults)
        setValue('children', context && context.additional_info && context.additional_info && context.additional_info.household && context.additional_info.household.children)
        setValue('store_location', context && context.additional_info && context.additional_info.store_location && context.additional_info.store_location.length > 0 && context.additional_info.store_location[0])
        setValue('category_preference', context && context.additional_info && context.additional_info.category_ids)
        setValue('how_you_want_to_shop_online', context.additional_info.shop_preference ? (context.additional_info.shop_preference.indexOf("online") > -1 ? "online" : "") : "")
        setValue('how_you_want_to_shop_instore', context.additional_info.shop_preference ? (context.additional_info.shop_preference.indexOf("in-store") > -1 ? "in-store" : "") : "")

        if (context && context.birthdate) {
            startDateHeandler(new Date(context.birthdate))
        }

        if (context && context.additional_info && context.additional_info.city_id) {
            updateStoreList(context.additional_info.city_id)
        }

        if (context && context.additional_info && context.additional_info.city_id && context.additional_info.store_location && context.additional_info.store_location.length > 0) {
            updateStoreList(context.additional_info.city_id)
            stores[context.additional_info.city_id].map((item, i) => {
                if (item.value === context.additional_info.store_location[0]) {
                    setPreferStoreIndex(i)
                }
            })
        }
    }, [context])

    useEffect(() => {
        const progressContainer = document.querySelector('.progress-container');
        const progressEl = progressContainer.querySelector('.progress');
        const percentageEl = progressContainer.querySelector('.percentage');

        progressEl.style.width = percentageEl.innerText = progress + '%';

        if (i18n.language === 'ar') {
            percentageEl.style.right = progress + '%';
        } else {
            percentageEl.style.left = progress + '%';
        }
    }, [progress, i18n.language])

    useEffect(() => {
        handleProgress()
    }, [])

    return (
        <>
            {context && <section className="banner-form">
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-5 col-md-12 col-sm-12 p-0">
                            <div className="panda-image left-box">
                                <img src="images/bg-overlay.png" className="bg-cover" alt="bg-cover" />
                                <div className="left-inner l">
                                    <img src="images/logo-form.png" alt="logo" />
                                    {context && context.firstname && <h3 className="text-white mt-5">{t('Hi')}, {context && context.firstname}</h3>}
                                    <h3 className="text-white mt-3">{t('Welcome to Panda Plus')}</h3>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-7 col-md-12 col-sm-12">
                            <div className="row d-flex justify-content-center">
                                <div className="col-lg-8 col-md-12 col-sm-12">
                                    <div className="main-form-section mt-4 mb-5 ">
                                        <form id="stepByStepForm" className="form-stepper" onSubmit={handleSubmit(submitRegistration)} onChange={handleProgress}>
                                            <div className="col-md-12">
                                                <ul className="step-content">
                                                    <li><span className='break-word bk-word text-light-green'>{t('Basic information')}</span></li>
                                                    <li><span className='break-word bk-word text-light-green'>{t('Other information')}</span></li>
                                                    <li><span className='break-word bk-word text-light-green'>{t('Preference')}</span></li>
                                                </ul>
                                                <ul className="progress-bar py-2 px-4">
                                                    <li className={`progress-bar__dot full ${steps > 1 && 'progress-check'}`}></li>
                                                    <li className={`progress-bar__connector ${steps > 1 && 'bar__connector_solid'}`}></li>
                                                    <li className={`progress-bar__dot ${steps > 1 && 'full'} ${steps > 2 && 'progress-check'}`}></li>
                                                    <li className={`progress-bar__connector ${steps > 2 && 'bar__connector_solid'}`}></li>
                                                    <li className={`progress-bar__dot ${steps > 2 && 'full'}  ${steps === 3 && 'progress-check'}`}></li>
                                                </ul>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="progress-container">
                                                    <div className={`progress ${progress === 100 && 'progress-100'}`}></div>
                                                    <div className="percentage">0%</div>

                                                </div>
                                            </div>

                                            <div className="main-form-panda ps-4 pe-4">
                                                <div className="step step1">
                                                    {steps > 0 && <div className="col-md-12">
                                                        <div className="form--header-container">
                                                            <h4 className="form--header-title pb-3 fw-bold text-dark py-3">
                                                                {t('Let us get to know you')}
                                                            </h4>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="firstname" className="form-label">{t('First Name')}<span>*</span></label>
                                                            <input type="text" id='firstname' {...register('firstname', { required: `${t('Required field')}` })} placeholder={t('First Name')} maxLength="32" />
                                                            <ErrorMessage errors={errors} name="firstname" render={({ message }) => <p className='error-message'>{message}</p>} />
                                                        </div>

                                                        <div className="mb-3">
                                                            <label htmlFor="lastname" className="form-label">{t('Last Name')}<span>*</span></label>
                                                            <input type="text" id='lastname' {...register('lastname', { required: `${t('Required field')}` })} placeholder={t('Last Name')} maxLength="32" />
                                                            <ErrorMessage errors={errors} name="lastname" render={({ message }) => <p className='error-message'>{message}</p>} />
                                                        </div>

                                                        <div className="mb-3">
                                                            <label htmlFor="mobile" className="form-label">{t('Mobile Number')}<span>*</span></label>
                                                            <div className="input-group numinput-wrap">
                                                                <span className="input-group-text" id="inputGroup-sizing-sm"><b>+966</b></span>
                                                                <input type='text' id='mobile' {...register('mobile', { required: `${t('Required field')}`, pattern: { value: /^5[0-9]{8}$/, message: `${t('Enter valid No')}` } })} className='form-control text-dark ' aria-describedby="inputGroup-sizing-sm" placeholder={t('Enter your no')} readOnly />
                                                            </div>
                                                            <ErrorMessage errors={errors} name="mobile" render={({ message }) => <p className='error-message'>{message}</p>} />
                                                        </div>
                                                        <div className="mb-3 required">
                                                            <label htmlFor="email" className="form-label">{t('Email')} <span>*</span></label>
                                                            <input type="text" id='email' {...register('email', { required: `${t('Required field')}`, pattern: { value: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: `${t('Email Invalid')}` } })} placeholder={t('Email')} maxLength="64" />
                                                            <ErrorMessage errors={errors} name="email" render={({ message }) => <p className='error-message'>{message}</p>} />
                                                        </div>
                                                        <div className="checkbox row mb-3">
                                                            <label className="col-sm-12 form-label checkbox-content mb-1">
                                                                {t('Be the first crazy deals')}
                                                            </label>
                                                            <div className="check-bg">
                                                                <div className="form-check form-check-inline ">
                                                                    <input className="form-check-input" id="marketing_opt_email" type="checkbox" {...register('marketing_opt_email')} value="true" />
                                                                    <label className="form-check-label text-muted ms-2" htmlFor="marketing_opt_email">{t('Yes to Email')} </label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" id="marketing_opt_mobile" type="checkbox" {...register('marketing_opt_mobile')} value="true" />
                                                                    <label className="form-check-label text-muted ms-2" htmlFor="marketing_opt_mobile">{t('Yes to Mobile')}</label>
                                                                </div>
                                                                {(!context.is_loyalty_customer || context.is_anonymous) && <div className="form-check form-check-inline mt-2" onClick={showTC}>
                                                                    <input className="form-check-input" type="checkbox" {...register('is_terms_accepted', { required: `${t('Required field')}` })} id="is_terms_accepted" value="true" />
                                                                    <label className="form-check-label text-muted ms-2">{t('Please accept')} <span className="brn-link text-primary">{t('Term & Condition')}</span></label>
                                                                    <ErrorMessage errors={errors} name="is_terms_accepted" render={({ message }) => <p className='error-message'>{message}</p>} />
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    </div>}
                                                </div>

                                                <div className="step step2 hidden">
                                                    {steps > 1 && <div className="col-md-12">
                                                        <div className="form--header-container">
                                                            <h4 className="form--header-title pb-3 fw-bold text-dark py-3">
                                                                {t('Tell us more about you')}
                                                            </h4>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="birthdate" className="form-label">{t('Birthday')}<span>*</span></label>
                                                            <div className="input-group">
                                                                <DatePicker
                                                                    selected={startDate}
                                                                    onChange={(date) => startDateHeandler(date)}
                                                                    selectsStart
                                                                    dateFormat={DATEPICKER_DATE}
                                                                    maxDate={new Date()}
                                                                    className="form-control input-group-field"
                                                                    name="birthdate"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                />
                                                                <FontAwesomeIcon icon={faCalendar} className="input-group-icon fs-14px" />
                                                                <span className='sub-title w-100'>{t('Share your birthday')}</span>
                                                                <ErrorMessage errors={errors} name="birthdate" render={({ message }) => <p className='error-message'>{message}</p>} />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label pt-1 mb-0 d-block">{t('Gender')}<span>*</span></label>
                                                            <div className="form-check form-check-inline">
                                                                <input className="form-check-input" type="radio" {...register('gender', { required: `${t('Required field')}` })} id="inlineradio1" value="male" />
                                                                <label className="form-check-label text-muted" htmlFor="inlineradio1">{t('Male')}</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input className="form-check-input" type="radio" {...register('gender', { required: `${t('Required field')}` })} id="inlineradio2" value="female" />
                                                                <label className="form-check-label text-muted" htmlFor="inlineradio2">{t('Female')}</label>
                                                            </div>
                                                            <ErrorMessage errors={errors} name="gender" render={({ message }) => <p className='error-message'>{message}</p>} />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">{t('City')}</label>
                                                            <div className="input-group">
                                                                <Select
                                                                    defaultValue={context && context.additional_info && context.additional_info.city_id ? cities[context.additional_info.city_id - 1] : ''}
                                                                    className="custom-react-select"
                                                                    classNamePrefix="custom-react-select"
                                                                    options={cities}
                                                                    id="city"
                                                                    theme={theme}
                                                                    placeholder={t('Select')}
                                                                    onChange={(selected) => { setValue('no_of_cities', selected.value); updateStoreList(selected.value); handleProgress() }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="address" className="form-label">{t('Address')}</label>
                                                            <input type="text" id='address' {...register('address')} placeholder={t('Address')} />
                                                            <ErrorMessage errors={errors} name="address" render={({ message }) => <p className='error-message'>{message}</p>} />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label py-1">{t('Martial Status')}</label>
                                                            <div className="input-group">
                                                                <Select
                                                                    defaultValue={context && context.additional_info && context.additional_info.marital_status ? maritalStatus[(context.additional_info.marital_status === 'single' ? 0 : (context.additional_info.marital_status === 'married' ? 1 : 2))] : ''}
                                                                    className="custom-react-select"
                                                                    classNamePrefix="custom-react-select"
                                                                    options={maritalStatus}
                                                                    isSearchable={false}
                                                                    id="marital_status"
                                                                    theme={theme}
                                                                    placeholder={t('Select')}
                                                                    onChange={(selected) => { setValue('marital_status', selected.value); handleProgress() }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label py-1">{t('Tell us how many people live with you?')}</label>
                                                            <div className="input-group g-2">
                                                                <Select
                                                                    defaultValue={context && context.additional_info && context.additional_info.household && context.additional_info.household.adults ? noOfFamilyMember[context.additional_info.household.adults] : ''}
                                                                    className={`custom-react-select w-49 ${i18n.language === 'ar' && 'ms-auto'}`}
                                                                    classNamePrefix="custom-react-select"
                                                                    options={noOfFamilyMember}
                                                                    isSearchable={false}
                                                                    id="adults"
                                                                    theme={theme}
                                                                    placeholder={t('Adults')}
                                                                    onChange={(selected) => { setValue('adults', selected.value); handleProgress() }}
                                                                />

                                                                <Select
                                                                    defaultValue={context && context.additional_info && context.additional_info.household && context.additional_info.household.children ? noOfFamilyMember[context.additional_info.household.children] : ''}
                                                                    className={`custom-react-select w-49 ${i18n.language === 'en' && 'ms-auto'}`}
                                                                    classNamePrefix="custom-react-select"
                                                                    options={noOfFamilyMember}
                                                                    isSearchable={false}
                                                                    id="children"
                                                                    theme={theme}
                                                                    placeholder={t('Children')}
                                                                    onChange={(selected) => { setValue('children', selected.value); handleProgress() }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>}
                                                </div>

                                                <div className="step step3 hidden">
                                                    {steps > 2 && <div className="col-md-12 ">
                                                        <div className="form--header-container">
                                                            <h4 className="form--header-title pb-3 fw-bold text-dark py-3">
                                                                {t('Tell us about you are like')}
                                                            </h4>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">{t('Prefered Store Location')}</label>
                                                            <div className="input-group">
                                                                <Select
                                                                    defaultValue={context && preferStoreIndex && preferStore[preferStoreIndex]}
                                                                    className="custom-react-select"
                                                                    classNamePrefix="custom-react-select"
                                                                    options={preferStore}
                                                                    // isMulti
                                                                    components={makeAnimated()}
                                                                    id="store_location"
                                                                    theme={theme}
                                                                    placeholder={t('Select')}
                                                                    onChange={(selected) => { setValue('store_location', selected.value); handleProgress() }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="mb-3">
                                                            <label className="form-label ">{t('Category preference')}</label>
                                                            <div className="input-group">
                                                                <Select
                                                                    defaultValue={context && context.additional_info && context.additional_info.category_ids && context.additional_info.category_ids.map(value => categories[value - 1])}
                                                                    className="custom-react-select"
                                                                    classNamePrefix="custom-react-select"
                                                                    options={categories}
                                                                    isMulti
                                                                    components={makeAnimated()}
                                                                    id="category_preference"
                                                                    theme={theme}
                                                                    placeholder={t('Select')}
                                                                    onChange={(selected) => { setValue('category_preference', selected); handleProgress(selected) }}
                                                                />
                                                                <span className='sub-title w-100'>{t('Tell us what you like for us')}</span>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3">
                                                            <label className="form-label ">{t('How you want to shop?')}</label>
                                                            <div className="store px-4 py-3">
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="checkbox" {...register('how_you_want_to_shop_instore')} id="inlineCheckbox1" value="in-store" />
                                                                    <label className="form-check-label text-muted" htmlFor="inlineCheckbox1">{t('In-store')}</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="checkbox" {...register('how_you_want_to_shop_online')} id="inlineCheckbox2" value="online" />
                                                                    <label className="form-check-label text-muted" htmlFor="inlineCheckbox2">{t('Online')}</label>
                                                                </div>
                                                                {/* <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" {...register('how_you_want_to_shop')} id="inlineCheckbox3" value="both" />
                                                                    <label className="form-check-label text-muted" htmlFor="inlineCheckbox3">{t('Both')}</label>
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    </div>}
                                                </div>
                                                <div className="submit-netx-p">
                                                    <div className="button-group">
                                                        {steps > 1 && <button type='button' onClick={() => goToStep(steps, false)} className="button-grey btn-hover w-25 me-2">
                                                            {t('Previous')}
                                                        </button>}

                                                        <button type="submit" className="button-grey btn-hover">
                                                            {reload && <span className="spinner-border spinner-border-sm mr-1"></span>} {steps === 3 ? t('Submit') : t('Next')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    {termsAndConditions && <><div className="modal fade show" id="termsConditionModal" tabindex="-1" role="dialog" aria-labelledby="termsConditionLabel" aria-hidden="true" style={{ display: 'block', paddingRight: '15px' }}>
                                        <div className="modal-dialog modal-lg" role="document">
                                            <div className="modal-content border-green-light">
                                                <div className="modal-header">
                                                    <h5 className="modal-title text-green" id="termsConditionLabel">{t('Term & Condition')}</h5>
                                                </div>
                                                <div className="modal-body text-muted" dangerouslySetInnerHTML={{ __html: termsAndConditions }}></div>
                                                <div className="modal-footer main-form-section">
                                                    <button type="button" className="button-grey btn-hover w-25" onClick={acceptTC}>{t('Accept')}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        <div className="modal-backdrop fade show"></div>
                                    </>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>}
        </>
    )
}
export default Registration;